import React from "react";
import MasterTable from "../BaseMaster/MasterTable";

function CentersTable() {
  return (
    <>
      <MasterTable endpoint="/centers" name="Centers" modalName="Center" />
    </>
  );
}

export default CentersTable;
